import { faUserCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IUserChild } from '@kcftech/prometheustypescriptapiclient';
import { Hyperlink } from 'components/link/Hyperlink';
import { useUserDateTimeFormat } from 'custom_hooks/useUserDateTimeFormat';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

const UserIcon = styled(FontAwesomeIcon)`
    color: ${tokens.text.link};
`;

export type ModalHistoryInfoRowProps = {
    user?: IUserChild;
    date: Date;
    type: 'updated' | 'created';
};

export function ModalHistoryInfoRow({ type, date, user }: ModalHistoryInfoRowProps) {
    const { formatDate } = useUserDateTimeFormat();
    const formattedDate = formatDate(date);

    const text = `${
        type === 'created' ? 'Created' : 'Last modified'
    } on ${formattedDate} `;

    return (
        <div className="my-20 flex-row align-center f-14">
            <UserIcon className="f-24 pr-10" icon={faUserCircle} />
            <span>
                {text}
                {user && (
                    <>
                        &nbsp;by{' '}
                        <Hyperlink href={`mailto:${user.UserEmail}`}>
                            {user.UserFirstName} {user.UserLastName}
                        </Hyperlink>
                    </>
                )}
            </span>
        </div>
    );
}
